import React, { useEffect } from "react";
import { RxCross1 } from "react-icons/rx";
import CustomButton from "../../../Components/Common/CustomButton";
import { TiTick } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { fetchLocations } from "../../../redux/locations/locationSlice";
import { clearUsersError } from "../../../redux/users/userSlice";
import toast from "react-hot-toast";
const UserAvailability = ({locations,setSelectedLocations,selectedLocations,handleUserAvailability,userLocations}) => {
  const { isLoading, error } = useSelector((state) => state.users);
 

  useEffect(() => {
    if (locations) {
      setSelectedLocations(
        locations
          .filter((ele) => ele.status !== false)
          .map((ele) => ({
            name: ele.displayName,
            address: ele.address.addressLine1,
            zipcode: ele.address.zipCode,
            id: ele._id,
            isSelected: userLocations.includes(ele._id) ? true : false,
          }))
      );
    }
  }, [locations]);

  useEffect(() => {}, [selectedLocations]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchLocations({
        currentPage: null,
        itemsPerPage: null,
        sortBy: null,
        order: null,
      })
    );
  }, []);

  const toggleSelection = (id, isSelected = null) => {
    setSelectedLocations(
      selectedLocations.map((location) =>
        location.id === id
          ? { ...location, isSelected: isSelected ?? !location.isSelected }
          : location
      )
    );
  };

 

  const selectedTags = selectedLocations.filter((ele) => ele.isSelected);

  return (
    <div className="px-6 bg-white rounded-xl max-h-[80vh] customScrollbar mx-auto mt-4">
      <div className="mb-2">
        <h3 className="text-base font-semibold text-gray-800 mb-2">
          Select Your Locations:
        </h3>
        <div className="flex flex-wrap gap-2 p-3 bg-gray-50 border border-gray-200 rounded-lg shadow-inner">
          {selectedTags.length > 0 ? (
            selectedTags.map((ele) => (
              <div
                key={ele.id}
                className="flex items-center bg-brand-600 text-white px-4 py-2 rounded-full shadow hover:bg-brand-700 transition duration-300"
              >
                {ele.displayName || ele.name}
                <RxCross1
                  className="cursor-pointer ml-2 hover:text-red-300"
                  onClick={() => toggleSelection(ele.id, false)}
                />
              </div>
            ))
          ) : (
            <p className="text-gray-500 p-2">No locations selected yet.</p>
          )}
        </div>
      </div>
      <div className="p-3 bg-white border border-gray-200 rounded-lg shadow-md max-h-[22rem] overflow-y-auto space-y-1">
        {selectedLocations.map((ele) => (
          <div
            key={ele.id}
            onClick={() => toggleSelection(ele.id)}
            className={`flex items-center justify-between p-2 rounded-lg cursor-pointer transition-all duration-300 ${
              ele.isSelected
                ? "bg-indigo-100 border-l-4 border-indigo-500 text-indigo-900 shadow-sm"
                : "bg-gray-100 border-l-4 border-gray-200 text-gray-700 hover:bg-gray-200"
            }`}
          >
            <p
              className={`text-sm ${
                ele.isSelected ? "font-bold" : ""
              } space-y-1`}
            >
              <span className="font-bold block">{ele.displayName || ele.name}</span>
              <span className="">{ele.address} </span>
              <span className=""> {ele.zipcode}</span>
            </p>
            {ele.isSelected && (
              <span className="text-sm text-green-700 font-medium">
                <TiTick size={25} />
              </span>
            )}
          </div>
        ))}
      </div>
      <div className="my-8 flex justify-center ">
        <CustomButton
          text={`Submit`}
          onClick={handleUserAvailability}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default UserAvailability;
